import { $api } from "@/utils/fetch.ts";

export const privateModelsQueryOptions = () =>
	$api.queryOptions("get", "/api/private-models");

export const useAddPrivateModelMutation = () =>
	$api.useMutation("post", "/api/private-models");

export const useUpdatePrivateModelMutation = () =>
	$api.useMutation("put", "/api/private-models/{id}");

export const useDeletePrivateModelMutation = () =>
	$api.useMutation("delete", "/api/private-models/{id}");

export const useTestPrivateModelMutation = () =>
	$api.useMutation("post", "/api/private-models/test");

export const connectionsQueryOptions = () =>
	$api.queryOptions("get", "/api/private-models/connections");

/** The models a connection's server offers right now (one upstream request). */
export const connectionModelsQueryOptions = (id: string) =>
	$api.queryOptions("get", "/api/private-models/connections/{id}/models", {
		params: { path: { id } },
	});

export const useAddConnectionMutation = () =>
	$api.useMutation("post", "/api/private-models/connections");

export const useUpdateConnectionMutation = () =>
	$api.useMutation("put", "/api/private-models/connections/{id}");

export const useDeleteConnectionMutation = () =>
	$api.useMutation("delete", "/api/private-models/connections/{id}");

export const useImportConnectionModelsMutation = () =>
	$api.useMutation("post", "/api/private-models/connections/{id}/models");

export const useDiagnoseConnectionMutation = () =>
	$api.useMutation("post", "/api/private-models/connections/{id}/diagnose");
